import { Group, Stack, Text, TextInput } from '@mantine/core'
import { useForm, zodResolver } from '@mantine/form'
import { ContextModalProps } from '@mantine/modals'
import Form from 'common/Form'
import PhoneNumberInput from 'common/inputs/PhoneNumberInput'
import { useAddExternalOrder } from 'hooks/orders'
import { NewExternalOrder } from 'types/orders'
import { externalOrderSchema } from 'types/schemas'
import { trimFormValues } from 'utils'

export default function GetNumberForOrderModal({ context, id }: ContextModalProps) {
  const getNumberForOrder = useAddExternalOrder()

  const form = useForm<NewExternalOrder>({
    validate: zodResolver(externalOrderSchema),
    transformValues: (values) =>
      trimFormValues(values, (v) => ({
        ...v,
        email: v.email || null,
        phoneNumber: v.phoneNumber ? v.phoneNumber.toString() : null,
        countryCode: v.phoneNumber ? v.countryCode || null : null,
      })),
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      countryCode: 48,
    },
  })

  if (getNumberForOrder.isSuccess) {
    return (
      <Group gap="xs">
        <Text>Wygenerowany numer zamówienia:</Text>
        <Text fw="bold">Z-{getNumberForOrder.data.id}</Text>
      </Group>
    )
  }
  return (
    <Form
      // onSubmit={async (values) => console.log(values)}
      onSubmit={async (values) => await getNumberForOrder.mutateAsync(values)}
      form={form}
      onCancel={() => context.closeModal(id)}
      submitText="Pobierz numer zamówienia"
    >
      <Stack gap="xs">
        <TextInput label="Imię" placeholder="Jan" withAsterisk {...form.getInputProps('firstName')} />
        <TextInput label="Nazwisko" placeholder="Kowalski" withAsterisk {...form.getInputProps('lastName')} />
        <TextInput label="Email" placeholder="email@gmail.com" {...form.getInputProps('email')} />
        <PhoneNumberInput form={form} />
      </Stack>
    </Form>
  )
}
